import React,{createContext} from 'react';

// Default to an empty object so components reading this context still work when
// rendered outside the provider (the standalone /service route, react-snap
// pre-rendering) instead of throwing on destructure.
const RefContext = createContext({});


export default RefContext;